module.exports = __webpack_public_path__ + "img/sambamaniacos-background.7a516f42.jpg";